import * as React from 'react';
export const fpxSvg = React.forwardRef(function fpxSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M10.841 15.657a318.161 318.161 0 0 0-2.48-3.343c-.133-.176-.326-.387-.55-.267-.153.08-.291.32-.307.5-.05.59-.047 1.183-.053 1.776 0 .067.064.14.11.202.346.469.699.934 1.043 1.404a.82.82 0 0 1 .167.34c-.017.142-.071.213-.167.345-.344.47-.697.937-1.043 1.407-.046.061-.11.137-.11.204.006.592.002 1.186.053 1.775.016.18.154.42.306.5.225.12.418-.093.55-.269a298.07 298.07 0 0 0 2.481-3.346c.146-.198.223-.332.237-.616a1.167 1.167 0 0 0-.237-.612Zm1.856 3.568c.388 0 .944.009 1.365.009v-2.412h2.567v-1.285h-2.55v-1.255h2.777v-1.231h-4.16v6.174Z',
      fill: '#1F2C5C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.278 15.657c.82-1.12 1.648-2.233 2.482-3.343.132-.176.325-.387.55-.267.152.08.29.32.306.5.05.59.047 1.183.053 1.776 0 .067-.064.14-.11.202-.346.469-.699.934-1.043 1.404a.819.819 0 0 0-.167.34c.017.142.071.213.167.345.344.47.697.937 1.043 1.407.046.061.11.137.11.204-.006.592-.002 1.186-.053 1.775-.016.18-.154.42-.306.5-.225.12-.418-.093-.55-.269a316.1 316.1 0 0 1-2.482-3.346c-.145-.198-.222-.332-.236-.616a1.16 1.16 0 0 1 .236-.612Z',
      fill: '#1A8ACB',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.88 12.99c1.094.04 2.183.013 3.253.144.974.118 1.428.87 1.373 1.979-.047.941-.635 1.548-1.635 1.648-.528.053-1.061.058-1.643.087v2.369h-1.347v-6.228Zm1.37 1.158v1.517c.44-.023.863-.01 1.273-.076.399-.064.575-.328.564-.7-.009-.34-.216-.598-.593-.651-.403-.057-.814-.061-1.244-.09Zm7.481 1.839 1.996-2.93c-.556 0-1.047-.006-1.537.008-.075.002-.172.087-.218.16-.203.323-.39.656-.584.985l-.562.957c-.142-.34-.371-.649-.553-.957-.193-.33-.372-.662-.575-.985-.045-.073-.142-.158-.218-.16-.49-.014-.98-.007-1.536-.007l1.995 2.93-2.243 3.272c.592 0 1.127.007 1.662-.01.067-.002.143-.124.192-.205.406-.659.8-1.322 1.203-1.983.025-.042.073-.083.073-.13.03.047.058.088.083.13.402.662.802 1.324 1.207 1.983.05.081.127.203.195.205.535.017 1.07.01 1.663.01l-2.243-3.273Z',
      fill: '#1F2C5C',
    }),
  );
});
fpxSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var fpx = {
  category: 'brand',
  colorable: false,
  name: 'fpx',
  svg: fpxSvg,
};
